export default __webpack_public_path__ + "static/The Home_Image 6_carousel 3@2x-1a056d71ff172dba80f1009ac4689e38.jpg";